import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Nullable } from '../common/types';
import { RootState } from './rootReducer';

export type RedirectType = {
  destination: string;
  search?: string;
  state?: any;
};

export type RedirectInitialState = {
  redirect: Nullable<RedirectType>;
};

export const redirectInitialState: RedirectInitialState = {
  redirect: null,
};

export const redirectSlice = createSlice({
  name: 'redirect',
  initialState: redirectInitialState,
  reducers: {
    setRedirect: (state, action: PayloadAction<RedirectType>) => {
      state.redirect = action.payload;
    },
  },
});

export const { setRedirect } = redirectSlice.actions;

export const redirectSelectors = {
  selectRedirect: (state: RootState) => state.redirect.redirect,
};

export default redirectSlice.reducer;
